Date.prototype.addDays = function(days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
}

var homesolar;
var hero_without_pic = false;

homesolar = {
  init: function() {
    homesolar.event();
    homesolar.updateBurger();
    homesolar.startAnim();
    homesolar.startSlideshow();
    homesolar.mergeGrid();
    homesolar.initOpenHours();
    
  },
  event: function() {
    $(".hs-menu").on("click", homesolar.openDrawerMenu);
    $(".hs-close-menu").on("click", homesolar.closeDrawerMenu);
    $(".hs-faq__item").on('click', homesolar.openFaq);
    $("[dt-select]").on("click", homesolar.selectContact)
    $(window).on('scroll', homesolar.updateBurger);
    $("[popup-close]").on("click", homesolar.closePopup);
    $(".hs-image-text__paragraph--ps a").on("click", homesolar.openPopup);
    $(".hs-popup__background, .menu-overlay").on("click", homesolar.closeBg);
  },
  openDrawerMenu: function() {
    $(".hs-menu-drawer").removeClass("inactive");
    $(".menu-overlay").fadeIn();
  },
  closeDrawerMenu: function() {
    $(".hs-menu-drawer").addClass("inactive");
    $(".menu-overlay").fadeOut();
  },
  openFaq: function() {
    $(this).toggleClass("actif").find(".hs-faq__response").slideToggle();
  },
  selectContact: function() {
    var dt = $(this).attr("dt-select");
    $('[dt-type], [dt-select]').removeClass("actif");
    $('[dt-type="' + dt + '"], [dt-select="' + dt + '"]').addClass("actif");
  },
  updateBurger: function() {
    var h = $('.hs-menu').offset().top;
    var h2 = $('.hs-hero').height();
    var h3 = $('[data-section-id="v2-footer"]').height();
    var h4 = $('[data-section-id="v2-footer"]').offset().top;

    console.log(h, h2, h3, h4);

    if (((!hero_without_pic && (h + 10 > h2 && h + 40 < h4)) && (h < h4 || h > h4 + h3))) {
      $('.hs-menu').removeClass("actif");
    } else if (hero_without_pic && h < h4 || h > h4 + h3) {
      $('.hs-menu').removeClass("actif");
    } else {
      $('.hs-menu').addClass("actif");
    }
  },
  startAnim: function() {
    if ($("[anim-h]").length > 0) {
      if ($(window).width() > 1023) {
        setTimeout(function() {
          var h = $(".houses-svg.only-desk").offset().top;
          $("[anim-h], [anim-y]").height(h - 500);
        }, 2000);
      } else {
        setTimeout(function() {
          var h = $(".houses-svg.only-phone").offset().top;
          $("[anim-h], [anim-y], [databar]").height(h - 170);
          $(".suns + [databar], [anim-h]").attr("viewBox", "0 0 3 " + h - 170);
          $("[autoh]").attr("y2", h - 170);
        }, 2000);
      }
    }

  },
  startSlideshow: function() {
    if ($(".splide").length > 0) {
      new Splide( '.splide', {
        type : 'loop',
        focus  : 'left',
        autoWidth: true
      } ).mount();
    }
  },
  closePopup: function() {
    var popup = $(this).attr("popup-close");
    if ($(window).width() < 768) {
      $('[popup-id="' + popup + '"] > .hs-popup__background + .hs-popup').removeClass("actif");
      setTimeout(function() {
        $('[popup-id]').fadeOut();
      }, 350);
    } else {
      $('[popup-id="' + popup + '"]').fadeOut();
    }
  },
  openPopup: function(event) {
    event.preventDefault();
    var popup = $(this).attr("title");
    if ($(window).width() < 768) {
      $('[popup-id="' + popup + '"]').fadeIn();
      setTimeout(function() {
        $('[popup-id="' + popup + '"] > .hs-popup__background + .hs-popup').addClass("actif");
      }, 350);
    } else {
      $('[popup-id="' + popup + '"]').fadeIn();
    }
  },
  mergeGrid: function() {
    if ($('[merge-items]').length > 0 && $(window).width() < 800) {
      var items1 = $('[merge-items="gr1"]').last().find(".grid").html();
      $('[merge-items="gr1"]').last().remove();
      $('[merge-items="gr1"]').first().find(".grid").append(items1);

      var items2 = $('[merge-items="gr2"]').last().find(".grid").html();
      $('[merge-items="gr2"]').last().remove();
      $('[merge-items="gr2"]').first().find(".grid").append(items2);

      var items3 = $('[merge-items="beka"]').last().find(".grid").html();
      $('[merge-items="beka"]').last().remove();
      $('[merge-items="beka"]').first().find(".grid").append(items3);
    }
  },
  initOpenHours: function() {
    var days = ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"]
    var today_day = new Date().getDay();
    console.log(today_day);
    var today_hours = hours_days[today_day];
    var current_hours = new Date().getHours();
    var current_minutes = new Date().getMinutes();
    if (today_hours == "closed") {
      var monday_hours = hours_days[1].split("-")[0];
      var open_string = "Ouvert lundi dès " + monday_hours;
    } else {
      var closed_at = today_hours.split("-")[1];
      var h = closed_at.split("h")[0];
      var m = closed_at.split("h")[1];
      if (current_hours > h || (current_hours == h && current_minutes > m)) {
        var new_day = new Date().addDays(1).getDay();
        if (new_day == 0) {
          new_day = 1;
        }
        var new_hours = hours_days[new_day];
        var new_closed_at = new_hours.split("-")[0];
        if (new_closed_at == "closed") {
          var monday_hours = hours_days[1].split("-")[0];
          var open_string = "Ouvert lundi dès " + monday_hours;
        } else {
          var open_string = "Ouvert " + days[new_day] + " dès " + new_closed_at; 
        }
      } else {
        var open_string = "Disponible jusqu'à " + closed_at;
      }
    }
    $(".hs-hero__phone p, .hs-menu-drawer .only-phone p, .Footer__phone + span").html('— ' + open_string);
    $("[data-open-hours]").html(open_string.replace("Disponible", ""));

  }, 
  closeBg: function() {
    $('[popup-id]').fadeOut();
    $(".hs-menu-drawer").addClass("inactive");
    $(".menu-overlay").fadeOut();
  }
};


$(document).ready(function() {

  if ($("#slidecarthq").length == 0) {
    if ($(".hs-hero__title--no-picture").length > 0) {
      hero_without_pic = true;
    }
    homesolar.init();
  } else {
    homesolar.initOpenHours(); 
  }

});

$(window).scroll(function() {
  if ($(window).scrollTop() > 50) {
    $("#netreviewsWidgetNum24432widget02av").addClass("netreviews-scrolled"); 
  } else if ($(window).scrollTop() > $(window).height() - 360) {
    $("#netreviewsWidgetNum24432widget02av").addClass("netreviews-scrolled"); 
  } else {
    $("#netreviewsWidgetNum24432widget02av").removeClass("netreviews-scrolled"); 
  }
});
